const SearchStorageKeys = {
  'recently-viewed-vehicles': 'recently-viewed-vehicles',
  usedCarsPreviousUrl: 'usedCarsPreviousUrl',
  newCarsPreviousUrl: 'newCarsPreviousUrl',
} as const

type SearchStorageKeys =
  (typeof SearchStorageKeys)[keyof typeof SearchStorageKeys]

export type SearchMode = 'used' | 'new'

export const DEFAULT_SEARCH_MODE_URLS: Record<SearchMode, string> = {
  used: '/used-cars?financeType=any',
  new: '/new-cars',
}

const SEARCH_MODE_STORAGE_KEY: Record<SearchMode, SearchStorageKeys> = {
  used: SearchStorageKeys.usedCarsPreviousUrl,
  new: SearchStorageKeys.newCarsPreviousUrl,
}

export const setSessionStorage = (
  storageKey: SearchStorageKeys,
  value: string,
) => {
  if (typeof window !== 'undefined') {
    window.sessionStorage.setItem(storageKey, value)
  }
}

export const getSessionStorage = <T = unknown>(
  storageKey: SearchStorageKeys,
): T => {
  const storageValue = window.sessionStorage.getItem(storageKey)
  return typeof storageValue === 'string' ? JSON.parse(storageValue) : ({} as T)
}

export const setSearchModeLastActiveUrl = (
  searchMode: SearchMode,
  url: string,
) => {
  setSessionStorage(SEARCH_MODE_STORAGE_KEY[searchMode], url)
}

export const setCurrentSearchModeUrl = (searchMode: SearchMode) => {
  if (typeof window !== 'undefined') {
    setSearchModeLastActiveUrl(searchMode, window.location.href)
  }
}

export const getSearchModeLastActiveUrl = (searchMode: SearchMode) => {
  if (typeof window !== 'undefined') {
    const storedUrl = window.sessionStorage.getItem(
      SEARCH_MODE_STORAGE_KEY[searchMode],
    )

    if (storedUrl) return storedUrl
  }

  return DEFAULT_SEARCH_MODE_URLS[searchMode]
}
